'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

require('./contact-us-modal.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _contactUsSuccess = require('./contact-us-success');

var _contactUsSuccess2 = _interopRequireDefault(_contactUsSuccess);

var _marketoForm = require('hellosign/components/marketo-form');

var _marketoForm2 = _interopRequireDefault(_marketoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * This is a Contact Us modal used on the HelloSign web and API pricing pages.
 */

var _ref = _jsx(_contactUsSuccess2['default'], {});

var _ref2 = _jsx('br', {});

var ContactUsModal = _react2['default'].createClass({
    displayName: 'ContactUsModal',


    propTypes: {
        'timePeriod': _react2['default'].PropTypes.string, // FIXME: We aren't actually using this
        'pricingSource': _react2['default'].PropTypes.string
    },

    getInitialState: function getInitialState() {
        return {
            'timePeriod': 'Y'
        };
    },

    componentDidMount: function componentDidMount() {
        $(document).foundation();
        $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
    },

    componentWillReceiveProps: function componentWillReceiveProps() {
        //
        $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
    },

    handleMarketoFormLoaded: function handleMarketoFormLoaded(form) {
        // Add values to hidden form fields
        // TODO: Ask Paul to add a hidden field for this, and supply timePeriod into it
        // form.vals({"userIsAwesome":"true", "enrollDate":"2014-01-01"});

        // TODO: Also set email/name from account profile if logged in
        var utm_source = '';
        var utm_campaign = '';
        var utm_medium = '';
        var parts,
            pairs = document.cookie.split(";");
        for (var k in pairs) {
            parts = $.trim(pairs[k]).split("=");
            if (parts.shift() == 'hf_source') {
                utm_source = atob(parts.join("="));
                break;
            }
        }

        for (var k in pairs) {
            parts = $.trim(pairs[k]).split("=");
            if (parts.shift() == 'hf_campaign') {
                utm_campaign = atob(parts.join("="));
                break;
            }
        }

        for (var k in pairs) {
            parts = $.trim(pairs[k]).split("=");
            if (parts.shift() == 'hf_medium') {
                utm_medium = atob(parts.join("="));
                break;
            }
        }

        form.setValues({
            "UTM_Source__c": utm_source,
            "UTM_Campaign__c": utm_campaign,
            "UTM_Medium__c": utm_medium
        });

        // Set up handler for when form is successfully submitted
        form.onSuccess(function (values, followUpUrl) {
            // Show thank you message
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'close');
            var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('contact_us_modal_success', 'medium');
            _reactDom2['default'].render(_ref, attachPoint);
            hellofaxJS.trackGoogleAnalyticsEvent('contactus', 'sales');

            // Return false to prevent the submission handler from taking the lead to the follow up url
            return false;
        }.bind(this));
    },

    render: function render() {
        // Change some stuff based on the pricingSource (web or api)
        var modalHeader = "Need to add more seats?";
        var marketoFormId = 1116; // Non-API Pricing Page Form
        if (this.props.pricingSource == "api") {
            modalHeader = "Need more?";
            marketoFormId = 1115; // API Pricing Page Form
        } else if (this.props.pricingSource == "eventbrite") {
                modalHeader = "Need more?";
                marketoFormId = 1214; // Eventbrite Pricing Page Form
            }

        return _jsx('div', {
            className: 'm-contact-us row text-center'
        }, void 0, _jsx('div', {
            className: 'columns small-12'
        }, void 0, _jsx('h3', {}, void 0, modalHeader)), _jsx('div', {
            className: 'row'
        }, void 0, _jsx('div', {
            className: 'columns small-10 small-offset-1 l-padding-t-10 l-padding-b-20'
        }, void 0, _jsx('p', {}, void 0, 'Please contact us at ', _jsx('strong', {
            id: 'corp-phone-number'
        }, void 0, _hfReactHelper2['default'].HfConstants.supportPhoneNumber), ',', _ref2, 'M-F 9am - 5pm PST, or email us and we\'ll get back to you right away!')), _jsx('div', {
            className: 'columns small-12'
        }, void 0, _jsx(_marketoForm2['default'], {
            formId: marketoFormId,
            onLoad: this.handleMarketoFormLoaded
        }))));
    }
});

module.exports = ContactUsModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/contact-us-modal.jsx
 ** module id = 789
 ** module chunks = 0
 **/